export default __webpack_public_path__ + "static/media/uvies-white.45b166fe.svg";